<div class="page-header" style="background: linear-gradient(90deg, #16A085, #1ABC9C);">
    <div class="main" style="padding-top: 0px;">
        <h1>
            Modification d'un Objet
        </h1>
    </div>
</div>
<div class="main items-theme" fxLayout="row" style="position: relative;">
    <item-form *ngIf="this.item" [(item)]="this.item" [editItem]="true"></item-form>
</div>